import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M18 6h-6a3 3 0 0 0 -3 3v10l-4 -4m8 0l-4 4","key":"svg-0"}]]

/**
 * IconCornerLeftDown
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY29ybmVyLWxlZnQtZG93biIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMTggNmgtNmEzIDMgMCAwIDAgLTMgM3YxMGwtNCAtNG04IDBsLTQgNCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/corner-left-down
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCornerLeftDown = createReactComponent('outline', 'corner-left-down', 'CornerLeftDown', __iconNode);

export default IconCornerLeftDown;